﻿$.fn.dxCtrlBuilderEmailPageMenu = function custom_dxCtrlBuilderEmailPageMenu(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailpagemenu dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailPageMenu(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailPageMenu = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxTabs = null
    var $DivDetail = null
    function mConstruit() {
        container.empty()
        container.css("position", "relative")

        var $Table = $("<table style='width:100%;border-bottom:" + theme.border + ";'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var ds = ["Widget", "Mise en page"]
        dxTabs = $("<div/>").appendTo($Td).dxTabs({
            dataSource: ds,
            selectedItem: ds[0],
            onItemClick: function (e) {
                switch (ds.indexOf(e.itemData)) {
                    case 0:
                        Me.mRempliButton()
                        option.onSelectButton()
                        break;
                    case 1:
                        Me.mRempliMiseEnPage()
                        option.onSelectMiseEnPage()
                        break;
                }
            }
        }).dxTabs("instance")
        ////if (parametre.isLocalhost) {
        ////    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        ////    $("<div/>").appendTo($Td).dxCtrlButton({
        ////        icon: "fa fa-plus",
        ////        hint:"Test email",
        ////        onClick: function () {
        ////            $("<div/>").appendTo("body").dxCtrlConstructEmailTest({
        ////                bddCtrl: option.bddCtrl,
        ////            })
        ////        }
        ////    })
        ////}
        //var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        //var $DivVisuAcid = $("<div/>").appendTo($Td).dxCtrlButton({
        //    icon: "fas fa-inbox",
        //    icon2: "fas fa-left-long",
        //    colorIcone2: theme.colorBtIcon2,
        //    opacityIcone2: "1",
        //    hint: "Prévisualisez votre message dans plus de 100 boites de réception parmi les plus populaires (outlook, gmail, free...)",
        //    onClick: function () {
        //        option.onDemandeVisuHideAcid()
        //        $DivVisuAcid.hide()
        //        $DivHideAcid.show()
        //    }
        //})
        //var $DivHideAcid = $("<div style='display:none'/>").appendTo($Td).dxCtrlButton({
        //    icon: "fas fa-inbox",
        //    icon2: "fas fa-right-long",
        //    colorIcone2: theme.colorBtIcon2,
        //    opacityIcone2: "1",
        //    hint: "Prévisualisez votre message dans plus de 100 boites de réception parmiedit email test les plus populaires (outlook, gmail, free...)",
        //    onClick: function () {
        //        option.onDemandeVisuHideAcid()
        //        $DivVisuAcid.show()
        //        $DivHideAcid.hide()
        //    }
        //})

        $DivDetail = $("<div style='height:calc(100% - " + dxTabs.element().innerHeight() + "px);position:relative;'/>").appendTo(container)
        resizeObserver.mAdd(dxTabs.element(), function () { $DivDetail.css("height", "calc(100% - " + dxTabs.element().innerHeight() + "px)") })
        Me.mRempliButton()

    }

    var dxScrollCurrent = null
    this.mGetDxScroll = function () { return dxScrollCurrent }

    var dxCurrent = null
    this.mRempliButton = function () {
        dxTabs.option("selectedIndex", 0)
        $DivDetail.empty()
        dxCurrent = $("<div style='height:100%;'/>").appendTo($DivDetail).dxCtrlBuilderEmailPageListeBouton({
            bddCtrl: option.bddCtrl,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            isFormulaire:option.isFormulaire
        }).dxCtrlBuilderEmailPageListeBouton("instance")
        dxScrollCurrent = dxCurrent.mGetDxScroll()
    }

    this.mRempliMiseEnPage = function () {
        dxTabs.option("selectedIndex", 1)
        $DivDetail.empty()
        dxCurrent = $("<div style='height:100%;'/>").appendTo($DivDetail).dxCtrlBuilderEmailPageMiseEnPage({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: option.onValueChanged,
            isFormulaire: option.isFormulaire
        }).dxCtrlBuilderEmailPageListeBouton("instance")
        dxScrollCurrent = dxCurrent.mGetDxScroll()
    }

    this.mRempliWidget = function (widgetElement) {
        dxTabs.option("selectedIndex", null)
        $DivDetail.empty();

        var cWidget = new cBuilderEmailWidget({
            bddCtrl: option.bddCtrl,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            element: widgetElement,
            onValueChanged: option.onValueChanged
        })

        var $DivMenu = $("<div style='position:absolute;top:0;right:0;height:100%;width:46px;background-color:" + theme.backgroundcolorTooltip + ";padding:5px;'/>").appendTo($DivDetail)

        $("<div style=''/>").appendTo($DivMenu).dxCtrlButton({
            icon: 'fas fa-arrow-turn-up',
            hint: "Quitter le widget",
            onClick: function (e) {
                option.onBackOnWidget()
                Me.mRempliButton()
            }
        })
        var $spTitle = $("<span style='transform:rotate(180deg);writing-mode:tb-rl;padding-bottom:10px;font-size:150%;padding-right:5px;'>" + (cWidget.widget.nom ? cWidget.widget.nom : "Saisie/" + cWidget.widget.nomBt) + "</span>").appendTo($DivMenu)
        $("<div style='height:calc(100% - " + (36 + 36 + 40 + $spTitle.innerHeight() + 55 + 10) + "px)'/>").appendTo($DivMenu)
        $("<div style='margin-bottom:15px;'/>").appendTo($DivMenu).dxCtrlButton({
            icon: 'fas fa-photo-film',
            icon2: 'fas fa-certificate',
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            hint: "Créer un nouveau widget à partir du widget sélectionné<br/>Le nouveau widget créé apparaitra dans la liste de vos widgets et pourra être utilisé dans tous vos emails",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    width: 500,
                    showCloseButton: true,
                    shading: true,
                    contentTemplate: function (contentElement) {
                        contentElement.addClass("dx-theme-material-typography")
                        contentElement.css("padding", "20px")
                        contentElement.css("border", theme.border)

                        option.bddCtrl.mAjaxCall({
                            command: "getdataswidgetemail"
                        }, function (data) {
                            data.lstwidgetperso = JSON.parse(data.lstwidgetperso)
                            //if (typeof data.lstwidgetperso == 'undefined') data.lstwidgetperso = []
                            var idx = 1
                            while (data.lstwidgetperso.filter(function (filtre) { return filtre.nom == "Nouveau widget #" + idx }).length > 0) {
                                idx += 1
                            }
                            $("<div style='font-size:200%;'>Nouveau widget</div>").appendTo(contentElement)
                            var dxNom = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                                labelMode: "floating",
                                label: "Nom du nouveau widget",
                                value: "Nouveau widget #" + idx
                            }).dxCtrlTextBox("instance")
                            var dxDescription = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                                labelMode: "floating",
                                label: "Description du nouveau widget",
                                value: ""
                            }).dxCtrlTextBox("instance")
                            var $Div = $("<div style='text-align:right;'/>").appendTo(contentElement)
                            $("<div style='display:inline-block'/>").appendTo($Div).dxCtrlButton({
                                text: "Créer le widget",
                                onClick: function (e) {
                                    if (dxNom.option("value") == null || dxNom.option("value").length == 0) {
                                        mNotify("Veuillez saisir un nom pour le widget", "warning", 6000)
                                    } else {
                                        var cloneEle = widgetElement.clone()
                                        cloneEle.removeClass("ui-draggable ui-draggable-handle selected")
                                        var dataWidgetEmail = option.bddCtrl.getObjet("widget_email").mGetNewData()
                                        dataWidgetEmail.nom = dxNom.option("value")
                                        dataWidgetEmail.description = dxDescription.option("value")
                                        dataWidgetEmail.html = cloneEle[0].outerHTML

                                        var lstFileHeberge = []
                                        widgetElement.find("a").each(function () {
                                            if (typeof $(this).attr("href") != 'undefined' && $(this).attr("href").startsWith("file:") && $(this).attr("href") != "file:") {
                                                var nom = $(this).attr("href").substring("file:".length)
                                                var url = option.lstfileheberge.filter(function (o) { return o.endsWith(nom) })[0]
                                                lstFileHeberge.push({
                                                    nom: nom,
                                                    url: url
                                                })
                                            }
                                        })
                                        var lstImage = []
                                        widgetElement.find("img").each(function () {
                                            if (typeof $(this).attr("src") != 'undefined' && $(this).attr("src").startsWith("/fichier/")) lstImage.push({ url: $(this).attr("src") })
                                        })

                                        tt.hide()

                                        var opt = {
                                            command: "createbuilderwidget",
                                            nom: dxNom.option("value"),
                                            description: dxDescription.option("value"),
                                            html: cloneEle[0].outerHTML
                                        }
                                        if (lstFileHeberge.length > 0) opt.lst_file_heberge = lstFileHeberge
                                        if (lstImage.length > 0) opt.lst_image = lstImage

                                        option.jauge.mShow()
                                        option.bddCtrl.mAjaxCall(opt, function (data) {
                                            lstWidgetPerso = null
                                            option.jauge.mHide()
                                            mNotify("Le widget '<b>" + dxNom.option("value") + "</b>' a été créé.", "success", 6000)
                                        })
                                        //option.bddCtrl.getObjet(dataWidgetEmail).mSave(function (data) {
                                        //})
                                    }
                                }
                            })
                            dxNom.focus()
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })
        $("<div style='margin-bottom:5px;'/>").appendTo($DivMenu).dxCtrlButton({
            icon: 'fas fa-copy',
            hint: "Dupliquer le widget",
            onClick: function (e) {
                option.onDuplikWidget()
            }
        })
        $("<div/>").appendTo($DivMenu).dxCtrlButton({
            icon: 'fas fa-xmark',
            hint: "Supprimer définitivement le widget du message",
            onClick: function (e) {
                option.onDeleteWidget()
                Me.mRempliButton()
                //var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                //    target: e.component.element(),
                //    contentTemplate: function (contentElement) {
                //        contentElement.css("padding", "20px")
                //        $("<div>Vous allez supprimer<br/>définitivement le widget</div>").appendTo(contentElement)
                //        $("<div style='margin-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                //            text: "Confirmer",
                //            onClick: function (e) {
                //                tt.hide()
                //                option.onDeleteWidget()
                //                Me.mRempliButton()
                //            }
                //        })
                //    }
                //}).dxCtrlTooltip("instance")
                //tt.show()
            }
        })

        var $DivLst = $("<div style='position:absolute;top:0;right:46px;height:100%;width:calc(100% - 46px);'/>").appendTo($DivDetail)

        dxScrollCurrent = cWidget.mRempliSaisie($DivLst)
    }

    this.element = function () { return container }

    mConstruit();
}